<template lang='pug'>
  #statics
    section.container
      .d-flex.flex-column.align-items-center.my-5
        h1.mb-4
          | {{ t('request_info.title') }}
        .border.rounded.p-3.w-75.overflow-auto
          div(v-if="!contactSaved")
            commercial-contact-form-vue(
              appSource='Solicitud Alta'
              :fullData="true"
              @save_request:successful="handleComercialContactSaveRequestSuccessful"
            )
          div(v-else)
            p.message-success(v-html="t('request_info.submit_message')")
            a.btn.btn-primary(
              :href="tolweb_base_url"
              data-test-id='goToHome'
            ) {{ t('request_info.go_to_home') }}
</template>

<script>
import mixins from 'common/mixins'

export default {
  name: 'request-info-vue',
  mixins: [mixins.translate],
  components: {
    'commercial-contact-form-vue': () => import(/* webpackChunkName: "[request]" */ 'components/CommercialContactForm')
  },
  data() {
    return {
      contactSaved: false
    }
  },
  methods: {
    handleComercialContactSaveRequestSuccessful() {
      this.contactSaved = true
    },
    resetForm() {
      this.contactSaved = false
    }
  }
}
</script>
